import React from 'react';
import { Container } from 'react-bootstrap';
import Clients from '../../../Litho/Components/Clients/Clients';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';

const clientData = [
	{ img: 'https://via.placeholder.com/120x60?text=Client+1', link: '#' },
	{ img: 'https://via.placeholder.com/120x60?text=Client+2', link: '#' },
	{ img: 'https://via.placeholder.com/120x60?text=Client+3', link: '#' },
	{ img: 'https://via.placeholder.com/120x60?text=Client+4', link: '#' },
];

const OceanClients = () => {
	return (
		<section className='py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px] overflow-hidden'>
			<Container>
				<Clients
					grid='row-cols-1 row-cols-md-4 row-cols-lg-4 row-cols-sm-2'
					theme='client-logo-style-03'
					data={clientData}
					animation={fadeIn}
				/>
			</Container>
		</section>
	);
};

export default OceanClients;
